import { useEffect } from 'react';
import { mask as maskBuild } from '../utils/mask';
export const useMask = ({
  mask,
  ref
}) => {
  useEffect(() => {
    if (!ref || !mask) {
      return;
    }

    return maskBuild({
      input: ref,
      options: mask
    });
  }, [ref]);
};